<!-- Regions Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <h3 class="fw-bold m-0">Regions Management</h3>
    </div>
    <div class="card-toolbar">
      <div class="d-flex justify-content-end" data-kt-region-table-toolbar="base">
        <!-- Add Region Button -->
        <button type="button" class="btn btn-sm btn-primary" (click)="openAddRegionModal()">
          <i class="ki-duotone ki-plus fs-2"></i>
          Add Region
        </button>
      </div>
    </div>
  </div>

  <!-- Search Section -->
  <div class="card-body py-4">
    <div class="d-flex align-items-center position-relative my-1">
      <i class="ki-duotone ki-magnifier fs-1 position-absolute ms-6">
        <span class="path1"></span>
        <span class="path2"></span>
      </i>
      <input
        type="text"
        [(ngModel)]="searchTerm"
        (keyup.enter)="onSearch()"
        class="form-control form-control-solid w-250px ps-15"
        placeholder="Search regions..."
      />
      <button
        type="button"
        class="btn btn-sm btn-primary ms-3"
        (click)="onSearch()"
      >
        Search
      </button>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Regions Table -->
    <div class="table-responsive">
      <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
        <thead>
          <tr class="fw-bold text-muted bg-light">
            <th class="min-w-200px">Region Name</th>
            <th class="min-w-100px text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          <!-- Loading State -->
          <tr *ngIf="isLoading">
            <td colspan="2" class="text-center py-5">
              <div class="d-flex align-items-center justify-content-center">
                <div class="spinner-border text-primary me-3" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <span class="text-muted">Loading regions...</span>
              </div>
            </td>
          </tr>

          <!-- No Data State -->
          <tr *ngIf="!isLoading && regions.length === 0">
            <td colspan="2" class="text-center py-5">
              <div class="d-flex flex-column align-items-center">
                <i class="ki-duotone ki-geolocation fs-3x text-muted mb-3">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                <span class="text-muted fs-6">No regions found</span>
              </div>
            </td>
          </tr>

          <!-- Data Rows -->
          <tr *ngFor="let region of regions; trackBy: trackByFn">
            <td>
              <div class="d-flex align-items-center">
                <div class="symbol symbol-45px me-5">
                  <div class="symbol-label bg-light-primary">
                    <i class="ki-duotone ki-geolocation fs-2 text-primary">
                      <span class="path1"></span>
                      <span class="path2"></span>
                    </i>
                  </div>
                </div>
                <div class="d-flex justify-content-start flex-column">
                  <span class="text-dark fw-bold text-hover-primary fs-6">
                    {{ region.name || '-' }}
                  </span>
                </div>
              </div>
            </td>
            <td class="text-end">
              <div class="d-flex justify-content-end flex-shrink-0">
                <!-- Edit Button -->
                <button
                  type="button"
                  class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                  (click)="openEditRegionModal(region)"
                  title="Edit Region"
                >
                  <i class="ki-duotone ki-pencil fs-2">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Delete Button -->
                <button
                  type="button"
                  class="btn btn-icon btn-bg-light btn-active-color-danger btn-sm"
                  (click)="deleteRegion(region)"
                  title="Delete Region"
                >
                  <i class="ki-duotone ki-trash fs-2">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                    <span class="path5"></span>
                  </i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <app-pagination
      *ngIf="!isLoading && regions.length > 0"
      [paginationInfo]="paginationInfo"
      [loading]="isLoading"
      (pageChange)="onPageChange($event)">
    </app-pagination>
  </div>
</div>

<!-- Region Add/Edit Modal -->
<app-add-edit-region (regionAdded)="onRegionAdded()" (regionUpdated)="onRegionUpdated()">
</app-add-edit-region>
